import { Component, input, InputSignal, output } from '@angular/core';

import { ButtonComponent, IconButtonComponent, IconComponent } from '@recruitee/user-interface';

@Component({
  selector: 'tla-survey-banner',
  templateUrl: './tellent-survey-banner.component.html',
  styleUrls: ['./tellent-survey-banner.component.less'],
  imports: [IconButtonComponent, IconComponent, ButtonComponent],
})
export class TellentSurveyBannerComponent {
  public title: InputSignal<string> = input.required();
  public description: InputSignal<string> = input.required();
  public buttonText: InputSignal<string> = input.required();

  public ctaClicked = output<void>();
  public hideClicked = output<void>();
}
